require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./classes-primaires-et-secondaires-1-0-7-1.json") })
        }
      }, "path---classes-primaires-et-secondaires-1-0-7-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---classes-primaires-et-secondaires-1-0-7-1!./.cache/json/classes-primaires-et-secondaires-1-0-7-1.json
// module id = 373
// module chunks = 231608221292675